import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateCertificate } from "PFApp/profiles/services/api";
import { Id, MutationOptions } from "PFTypes";
import { Certificate, CertificatePayload } from "PFTypes/certificate";

import { certificateKeys } from "./query_keys";

type Error = { response: { data: { errors: unknown[] } } };

export const useCertificateUpdate = ({ onSuccess, ...queryParams }: MutationOptions<Id>) => {
  const queryClient = useQueryClient();

  return useMutation<CertificatePayload, Error, any>({
    mutationFn: (payload: CertificatePayload): any => updateCertificate(payload),
    onSuccess: (resp: Certificate, ...otherArgs) => {
      queryClient.invalidateQueries({ queryKey: certificateKeys.all() });
      queryClient.invalidateQueries({ queryKey: certificateKeys.single(resp.id) });
      onSuccess?.(resp, ...otherArgs);
    },
    ...queryParams
  });
};
